import { type State } from "./activeLearningPath.state";

export enum ActionTypes {
  SET_ACTIVE_LEARNING_PATH = "SET_ACTIVE_LEARNING_PATH",
}

export const setActiveLearningPath = (learningPathId: State) => ({
  type: ActionTypes.SET_ACTIVE_LEARNING_PATH as const,
  payload: {
    learningPathId,
  },
});

const Actions = {
  setActiveLearningPath,
};

export type GenericAction = {
  type: string;
  payload?: { learningPathId?: State };
};

export type Actions = typeof Actions;
export type ActionKeys = keyof Actions;
export type Action = Actions[ActionKeys];
export type ActionReturns = ReturnType<Action> | GenericAction;
